import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "17",
      fill: "#EB7161",
      opacity: ".29"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "7",
      fill: "#ED4B34"
    }, null, -1)
  ]))]))
}
export default { render: render }